import React, {
  createContext, useState, useEffect, useContext,
} from 'react';

interface IThemeContext {
  getContentWidth: () => number;
}

const ThemeContext = createContext<IThemeContext>({ getContentWidth: () => 0 });

export const useThemeContext = (): IThemeContext => useContext(ThemeContext);

export const ThemeProvider: React.FC = ({ children }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const getContentWidth = () => windowWidth - 32;

  useEffect(() => {
    const resizeListener = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', resizeListener);

    return () => window.removeEventListener('resize', resizeListener);
  });

  return (
    <ThemeContext.Provider
      value={{
        getContentWidth,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
